import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ConversationList } from '@/components/conversation/ConversationList';
import { ConversationChat } from '@/components/conversation/ConversationChat';
import { Candado } from '@/components/athena/Candado';
import * as candado from '@/hooks/candado';
import { cn } from '@/lib/cn';

/**
 * CHATS — la bandeja completa, como la de cualquier Conversia.
 *
 * Layout tipo WhatsApp Web: lista de conversaciones a la izquierda, chat a la
 * derecha. El id seleccionado vive en la URL (`/conversations/:id`) para que
 * sea enlazable y refrescable.
 *
 * ═══ CON LLAVE ═══
 *
 * Esteban, 22-sep-2026: *"incluso para entrar a los chats que haya una pequeña
 * clave para verlos"*.
 *
 * Es el mismo candado de los frentes: la primera vez pide crear un PIN de seis
 * números, y después abre con la huella del equipo o con el PIN. Queda abierto
 * dos minutos después de salir; al volver más tarde, la pide otra vez.
 *
 * Protege la PANTALLA, no los datos: es para que quien agarra el teléfono o la
 * computadora no entre a leer. No esconde nada de alguien que sabe usar la
 * consola del navegador con la sesión abierta. Lo dice el propio candado.
 */
export default function Conversations() {
  const { id } = useParams();
  const navigate = useNavigate();
  // Los filtros de la lista viven en la URL: abrir un chat no los borra.
  const { search } = useLocation();
  // Se lee al montar: mientras el dueño está adentro no se le vuelve a pedir.
  const [abierto, setAbierto] = useState(() => candado.estaAbierto());

  if (!abierto) {
    return (
      <Candado
        nombreDelFrente="Chats"
        onAbierto={() => setAbierto(true)}
        onCancelar={() => navigate('/')}
      />
    );
  }

  return (
    <div className="flex h-full overflow-hidden">
      <div className={cn('h-full', id ? 'hidden sm:flex' : 'flex w-full sm:w-auto')}>
        <ConversationList selectedId={id} onSelect={(cid) => navigate({ pathname: `/conversations/${cid}`, search })} />
      </div>
      <div className={cn('h-full min-w-0 flex-1', id ? 'flex' : 'hidden sm:flex')}>
        <ConversationChat conversationId={id} />
      </div>
    </div>
  );
}
